module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.c0ff03d3.png";